import * as turf from '@turf/turf'

interface SavedMonitoringSite {
  id: string
  name: string
  location: number[]
  isRandomSite?: boolean
  randomizeCounter?: number | null
  seed?: number | null
  randomizeReason?: unknown
}

/**
 * Mapea un sitio de monitoreo persistido (forma de la API) a un Feature GeoJSON
 * para el panel de planificación.
 *
 * Restaura randomizeCounter, seed y randomizeReason además de los datos de
 * identidad: sin ellos, tras guardar y recargar el plan se perdía el contador y
 * la regla de "máximo de re-aleatorizaciones por sitio" se reiniciaba en la
 * misma sesión.
 */
export function mapSavedSiteToFeature(site: SavedMonitoringSite, strataName: string) {
  const feature = turf.point([site.location[1], site.location[0]])
  feature.properties.name = site.name
  feature.properties.id = site.id
  feature.properties.isRandomSite = site.isRandomSite
  feature.properties.strata = strataName
  feature.properties.randomizeCounter = site.randomizeCounter
  feature.properties.seed = site.seed
  feature.properties.randomizeReason = site.randomizeReason
  return feature
}
